/* NOSEKNOWS glitch.js - bounded, visibility-aware burst effects. */
(function(){
  "use strict";

  var body = document.body;
  var ui = document.getElementById("nk-ui");
  var scan = document.getElementById("nk-scan");
  var canvas = document.getElementById("nk-static");
  if (!ui || !canvas || !scan) return;

  var motionQuery = window.matchMedia("(prefers-reduced-motion: reduce)");
  var ctx = canvas.getContext("2d", { alpha: true });
  var off = document.createElement("canvas");
  var offCtx = off.getContext("2d", { alpha: true });
  if (!ctx || !offCtx) return;

  var W = 1;
  var H = 1;
  var offW = 180;
  var offH = 100;
  var idleTimer = null;
  var scheduleTimer = null;
  var modeTimer = null;
  var activeBurst = false;

  function getCSS(name, fallback){
    var raw = getComputedStyle(document.documentElement).getPropertyValue(name).trim();
    var value = parseFloat(raw);
    return Number.isFinite(value) ? value : fallback;
  }
  function rand(min, max){ return min + Math.random() * (max - min); }
  function sign(){ return Math.random() < 0.5 ? -1 : 1; }
  function parseISO(value){
    if (!value) return null;
    var date = new Date(value);
    return Number.isNaN(date.getTime()) ? null : date;
  }

  function decideMode(){
    var override = (body.dataset.nkMode || "auto").trim();
    if (override !== "auto") return override;
    var dropAt = parseISO(body.dataset.nkDropAt);
    if (!dropAt) return "normal";
    var hours = (dropAt.getTime() - Date.now()) / 3600000;
    var preDropHours = parseFloat(body.dataset.nkPreDropHours || "48") || 48;
    var liveHours = parseFloat(body.dataset.nkLiveHours || "4") || 4;
    if (hours <= 0 && Math.abs(hours) <= liveHours) return "live";
    if (hours > 0 && hours <= preDropHours) return "pre_drop";
    return "normal";
  }
  function syncMode(){ body.dataset.nkEffectiveMode = decideMode(); }

  function resize(){
    W = Math.max(1, window.innerWidth || document.documentElement.clientWidth || 1);
    H = Math.max(1, window.innerHeight || document.documentElement.clientHeight || 1);
    canvas.width = W;
    canvas.height = H;
    offH = Math.max(90, Math.min(240, Math.round(offW * H / W)));
    off.width = offW;
    off.height = offH;
    ctx.imageSmoothingEnabled = false;
  }

  function renderStatic(strength){
    if (document.hidden || motionQuery.matches || W < 1 || H < 1) return;
    var image = offCtx.createImageData(offW, offH);
    var data = image.data;
    var threshold = 1 - Math.min(0.65, strength);
    for (var i = 0; i < data.length; i += 4){
      var random = Math.random();
      var value = random > threshold ? 200 + Math.random() * 55 : Math.random() * 65;
      data[i] = data[i + 1] = data[i + 2] = value;
      data[i + 3] = random > threshold ? 255 : 0;
    }
    offCtx.putImageData(image, 0, 0);
    ctx.clearRect(0, 0, W, H);
    ctx.globalAlpha = 0.9;
    ctx.drawImage(off, 0, 0, W, H);
  }

  function stopIdle(){
    if (idleTimer) window.clearInterval(idleTimer);
    idleTimer = null;
  }
  function startIdle(){
    stopIdle();
    if (document.hidden || motionQuery.matches || decideMode() === "off") return;
    renderStatic(0.1);
    idleTimer = window.setInterval(function(){ renderStatic(0.1); }, 400);
    canvas.style.opacity = String(getCSS("--idleStatic", 0.04));
    scan.style.opacity = String(getCSS("--scanOpacity", 0.08));
  }

  function tickVars(intensity){
    var splitMax = getCSS("--splitMax", 6) * intensity;
    var blurMax = getCSS("--labelBlurMax", 1.2) * intensity;
    body.style.setProperty("--tx", sign() * rand(0, 2.2 * intensity) + "px");
    body.style.setProperty("--ty", sign() * rand(0, 1.4 * intensity) + "px");
    body.style.setProperty("--sk", sign() * rand(0, 1.1 * intensity) + "deg");
    body.style.setProperty("--rx", sign() * rand(1, splitMax) + "px");
    body.style.setProperty("--ry", sign() * rand(0.2, splitMax * 0.55) + "px");
    body.style.setProperty("--labelBlur", rand(0.2, blurMax) + "px");
    var top = rand(0, 70);
    var height = rand(8, 30);
    body.style.setProperty("--ct", top.toFixed(1) + "%");
    body.style.setProperty("--cb", Math.max(0, 100 - top - height).toFixed(1) + "%");
    scan.style.opacity = String(rand(getCSS("--scanOpacity", 0.08), getCSS("--scanBurst", 0.18)));
  }

  window.NK_BURST = function(options){
    options = options || {};
    if (activeBurst || document.hidden || motionQuery.matches || decideMode() === "off") return;
    activeBurst = true;
    stopIdle();
    body.classList.add("nk-burst");
    try { document.dispatchEvent(new Event("nk:burst")); } catch (_error) {}
    canvas.style.opacity = String(getCSS("--burstStatic", 0.24));

    var duration = Math.min(220, Math.max(70, options.duration || 140));
    var intensity = Math.min(1.25, Math.max(0.5, options.intensity || 1));
    var start = performance.now();
    var lastTick = 0;
    var lastNoise = 0;
    function frame(now){
      if (document.hidden || now - start >= duration){
        body.classList.remove("nk-burst");
        activeBurst = false;
        startIdle();
        return;
      }
      if (now - lastTick >= 32){
        lastTick = now;
        tickVars(intensity);
      }
      if (now - lastNoise >= 64){
        lastNoise = now;
        renderStatic(0.55 * intensity);
      }
      window.requestAnimationFrame(frame);
    }
    window.requestAnimationFrame(frame);
  };

  function schedule(){
    if (scheduleTimer) window.clearTimeout(scheduleTimer);
    if (document.hidden || motionQuery.matches || decideMode() === "off") return;
    var gap = rand(getCSS("--burstGapMin", 900), getCSS("--burstGapMax", 3200));
    scheduleTimer = window.setTimeout(function(){
      window.NK_BURST({ duration: rand(90, 170), intensity: rand(0.8, 1.15) });
      schedule();
    }, gap);
  }

  document.addEventListener("focusin", function(event){
    var target = event.target;
    if (target && (target.tagName === "INPUT" || target.tagName === "TEXTAREA")) {
      window.NK_BURST({ duration: 130, intensity: 1 });
    }
  });
  document.addEventListener("visibilitychange", function(){
    if (document.hidden){
      stopIdle();
      if (scheduleTimer) window.clearTimeout(scheduleTimer);
      scheduleTimer = null;
      body.classList.remove("nk-burst");
      activeBurst = false;
    } else {
      syncMode();
      startIdle();
      schedule();
    }
  });
  motionQuery.addEventListener("change", function(){
    body.classList.remove("nk-burst");
    activeBurst = false;
    startIdle();
    schedule();
  });
  window.addEventListener("resize", resize, { passive: true });
  window.addEventListener("pagehide", function(){
    stopIdle();
    if (scheduleTimer) window.clearTimeout(scheduleTimer);
    if (modeTimer) window.clearInterval(modeTimer);
    scheduleTimer = null;
    modeTimer = null;
  }, { once: true });

  resize();
  syncMode();
  modeTimer = window.setInterval(syncMode, 30000);
  startIdle();
  schedule();
})();
